var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4156 9.25313C29.2562 8.65949 28.9437 8.11814 28.5094 7.68324C28.075 7.24834 27.5341 6.93514 26.9406 6.775C24.7562 6.1875 16 6.1875 16 6.1875C16 6.1875 7.24375 6.1875 5.05937 6.77187C4.46569 6.9315 3.92445 7.24452 3.49002 7.6795C3.05558 8.11448 2.74325 8.65611 2.58437 9.25C2 11.4375 2 16 2 16C2 16 2 20.5625 2.58437 22.7469C2.90625 23.9531 3.85625 24.9031 5.05937 25.225C7.24375 25.8125 16 25.8125 16 25.8125C16 25.8125 24.7562 25.8125 26.9406 25.225C28.1469 24.9031 29.0937 23.9531 29.4156 22.7469C30 20.5625 30 16 30 16C30 16 30 11.4375 29.4156 9.25313ZM13.2188 20.1875V11.8125L20.4688 15.9688L13.2188 20.1875Z",
    fill: "#CD201F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeFilled);
export default __webpack_public_path__ + "static/media/YoutubeFilled.0893dd26170de3fa7fdaaf913ebf6819.svg";
export { ForwardRef as ReactComponent };